module.exports = __webpack_public_path__ + "static/media/Postman Logo.251608ea.png";